import theme from "src/theme";

const styles = {
  manageContainer: {},
  infoContainer: {
    padding: 16,
    backgroundColor: '#E2EDFF',
    marginBottom: 16,
    marginTop: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 8
  },
  infoTextContainer: {
    marginLeft: 16
  },
  infoIcon: {
    color: '#3E8AFF'
  },
  infoText: {
    fontSize: 14,
    color: '#3E8AFF',
    fontWeight: 500,
    lineHeight: '22px'
  },
  fileLink: {
    fontSize: 14,
    fontWeight: 500,
    paddingTop: 4,
    color: theme.palette.text.highlight2
  },
  linkButton: {
    fontSize: 14,
    fontWeight: 500,
    paddingTop: 16,
    color: theme.palette.text.highlight2,
    cursor: 'pointer'
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  customerApiDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 8
  },
  labelWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: 100,
  },
  longlabelWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: 130,
  },
  labelText: {
    fontSize: 14,
    fontWeight: 500,
    color: '#334D6E',
    width: '100%',
  },
  savedChip: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 16,
    fontSize: 10,
    color: '#FFFFFF',
    backgroundColor: '#4caf50',
    width: 60,
    height: 16,
    padding: '0px 12px'
  },
  inputField: {
    fontSize: 14,
    color: '#334D6E',
    border: 0,
    backgroundColor: '#E9E9E9',
    padding: '8px 12px',
    flex: 1,
    margin: '0px 8px',
    borderRadius: 4
  },
  customInputContainerStyle: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flex: 1
  },
  checkIcon: {
    color: '#4caf50'
  },
  checkConnectionBtn: {
    fontSize: 14,
    color: '#334D6E',
    border: theme.palette.border.manage,
    textTransform: 'none'
  },
  checkContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 16
  },
  syncBtn: {
    fontSize: 14,
    color: '#334D6E',
    border: theme.palette.border.manage,
    textTransform: 'none',
  },
  loadingProgress: {
    marginLeft: 16
  },
  errorContainer: {
    display: 'flex',
    padding: '6px 0px 0px 48px'
  },
  labelTextError: {
    fontSize: 14,
    fontWeight: 500,
    color: '#f54248',
  },
  qbConnectText: {
    fontSize: 14,
    fontWeight: 500,
    color: '#334D6E',
  },
  qbConnectBtn: {
    fontSize: 13,
    color: '#334D6E',
    border: theme.palette.border.manage,
    textTransform: 'none',
    marginLeft: 8,
    padding: '3px 8px'
  },
  integrationBody: {
    flex: 1,
    marginTop: '5px',
    marginBottom: '-10px'
  },
  integrationTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: '#334D6E'
  },
  integrationDesc: {
    fontSize: 14,
    color: '#334D6E',
    minHeight: 42
  },
  lineBreaker: {
    color: 'lightgray',
    height: 2,
    marginTop: 8,
    marginBottom: 8
  },
  manageExportBtn: {
    backgroundColor: '#3E8AFF1A',
    padding: '4px 9px 4px 9px',
    borderRadius: '4px',
    height: '36px',
    textTransform: 'none',
    color: '#3E8AFF',
    fontWeight: '600',
    fontSize: '14px',
    border: 'none',
    '&:hover': {
      backgroundColor: '#3E8AFF1A',
      boxShadow: '0px 8px 16px -8px #4C4E646B',
      border: 'none',
    }
  },
  drawerStyles: {
    drawer: {
      '& .MuiDrawer-paper': {
        width: { xs: '100%', sm: '50%', md: '400px' },
        height: '100%',
        maxHeight: '100%'
      }
    },
    container: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    modalHeader: {
      height: '72px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      borderBottom: '1px solid #e0e0e0',
      padding: '16px',
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    headerTitle: {
      fontSize: '18px',
      fontWeight: '500',
      color: '#333',
      lineHeight: '28px',
    },
    closeBtn: {
      padding: '0px',
    },
    closeIcon: {
      height: '18px',
      width: '18px',
      color: '#666',
    },
    modalContent: {
      flex: 1,
      padding: '20px 24px',
      overflow: 'auto',
    },
    jsonContainer: {
      position: 'relative',
      width: '100%',
      bgcolor: '#f5f5f5',
      borderRadius: '2px',
      marginTop: '16px',
    },
    jsonPre: {
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      backgroundColor: '#f5f5f5',
      color: '#333',
      fontSize: '13px',
      fontWeight: '400',
      padding: '16px',
      overflowX: 'auto',
    },
    copyBtn: {
      padding: '6px',
    },
    copyIcon: {
      width: '18px',
      height: '18px',
    },
    checkIcon: {
      color: '#4caf50',
      width: '18px',
      height: '18px',
      marginLeft: '4px',
    },
    copyIconContainer: {
      position: 'absolute',
      top: '5px',
      right: '5px',
      display: 'flex',
      alignItems: 'center',
    },
    contentNote: {
      fontSize: '14px',
      color: '#666',
    }
  },
  gridDetailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '8px',
  },
  gridCheckContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '16px',
  },
  interfaceIcon: {
    width: '12px',
    height: '12px',
    marginLeft: '4px',
  },
  labelTooltipWrapper: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 'max-content',
  },
  btnsWrapper: {
    display: 'flex',
    paddingRight: '8px',
    marginTop: '12px',
    justifyContent: 'space-between'
  }
};

export default styles;
